import React, {Fragment, useEffect, useRef, useState} from "react";
import {s_char} from "../_signals/s_char";
import CharName from "../CharHeader/CharName";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MobileFriendlyIcon from "@mui/icons-material/MobileFriendly";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import ComputerIcon from "@mui/icons-material/Computer";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useSignals} from "@preact/signals-react/runtime";
import Char from "../Char/Char";
import Chars from "../Chars/Chars";
import CharNSC from "../Char/CharNSC";
import {Box, Snackbar} from "@mui/material";
import Initiative from "../Initiative/Initiative";
import RolledList from "../RolledList/RolledList";
import {
    s_app_mobile, s_app_mobile_tab,
    s_app_sl,
    s_app_toggleMobile
} from "../_signals/s_app";
import Disciplines from "../Char/Disciplines/Disciplines";
import Talents from "../Char/Talents/Talents";
import TalentSkillPopover from "../PopoverTalentSkill/TalentSkillPopover";
import LP from "../Char/LP/LP";
import Notes from "../Char/Notes/Notes";
import Coins from "../Char/Coins/Coins";
import Diary from "../Char/Diary/Diary";
import Skills from "../Char/Skills/Skills";
import Weapons from "../Char/Weapons/Weapons";
import Armor from "../Char/Armor/Armor";
import MatriceSpell from "../Char/MatriceSpell/MatriceSpell";
import SpellPopover from "../PopoverSpell/SpellPopover";
import Threads from "../Char/Threads/Threads";
import BloodMagicItems from "../Char/BloodMagicItems/BloodMagicItems";
import Presets from "../Char/Roll/Presets";
import BloodMagicItemPopover from "../PopoverBloodMagicItem/BloodMagicItemPopover";
import DisciplinePopover from "../PopoverDiscipline/DisciplinePopover";
import {logout} from "../_helper/logout";
import Roll from "../Char/Roll/Roll";
import Stack from "@mui/material/Stack";
import WebSocketService from "./WebsocketService";
import Roller from "../Roller/Roller";

interface MsgBase {
    type: string
}

function Main() {
    useSignals()

    const [tab, setTab] = useState('char');
    const [hasIni, setHasIni] = useState(false);
    const [newRound, setNewRound] = useState(false);

    const menu = [
        {k: 'char', v: 'Charakter'},
        {k: 'roll', v: 'Würfeln'},
        {k: 'ini', v: 'Initiative'},
        {k: 'skills', v: 'Fertigkeiten'},
        {k: 'disciplines', v: 'Disziplinen'},
        {k: 'talents', v: 'Talente'},
        {k: 'weapons', v: 'Waffen'},
        {k: 'armor', v: 'Rüstung'},
        {k: 'matrixspell', v: 'Zaubern'},
        {k: 'threads', v: 'Fäden'},
        {k: 'other', v: 'LP & Münzen'},
        {k: 'diarynotes', v: 'Tagebuch/Notizen'},
        {k: 'bloodmagic', v: 'Blutmagie'},
        {k: 'chars', v: 'Szene'},
    ]


    const handleNewRoundClose = () => {
        setNewRound(false);
    }

    const showSLTab = (show: string) => {
        return s_app_sl.value && (!s_app_mobile.value || (s_app_mobile.value && tab === show));
    }

    const showTab = (show: string) => {
        return (!s_app_mobile.value || (s_app_mobile.value && tab === show));
    }

    return <Fragment>
        <Roller/>
        <TalentSkillPopover/>
        <SpellPopover/>
        <BloodMagicItemPopover/>
        <DisciplinePopover/>
        <Snackbar
            open={newRound}
            autoHideDuration={600}
            message="Neue Runde"
            onClose={handleNewRoundClose}
        />

        <WebSocketService
            onNewRound={setNewRound}
            onHasIni={setHasIni}
        />

        {hasIni ? <div
            style={{
                position: 'fixed',
                top: -18,
                right: -18,
                marginRight: -8,
                backgroundColor: 'rgba(45, 174, 45, 0.8)',
                width: 90,
                height: 40,
                rotate: '45deg'
            }}>
        </div> : null}
        <div className={'header'}>
            <CharName></CharName>
        </div>
        <div className={'main'}>
            {!s_char.value.nsc && showTab('char') ? <Char/> : null}
            {s_char.value.nsc && showTab('char') ? <CharNSC/> : null}

            {(s_app_mobile.value && tab === 'chars') || !s_app_mobile.value ? <Fragment>
                <Chars/>
            </Fragment> : null}

            {s_app_mobile.value && tab === 'roll' ? <Stack direction={'column'}>
                <Box style={{flexGrow: 3}}>
                    <Roll/>
                </Box>
                <Box style={{flexGrow: 1}}>
                    <RolledList/>
                </Box>
            </Stack> : null}

            {s_app_mobile.value && tab === 'ini' ? <Initiative/> : null}

            {!s_app_mobile.value ? <Fragment>
                <Presets/>

                <Grid container columnSpacing={{xs: 1}}>
                    <Grid item xs={12}>
                        <Initiative></Initiative>
                    </Grid>
                </Grid>
                <RolledList/>
            </Fragment> : null}

            {showTab('disciplines') ? <Disciplines/> : null}

            {showTab('talents') ? <Talents roll={false}/> : null}

            {showTab('other') ? <Fragment>
                <LP/>
                <Coins/>
            </Fragment> : null}

            {showTab('diarynotes') ? <Fragment>
                <Diary/>
                <Notes/>
            </Fragment> : null}

            {showTab('skills') ? <Skills roll={false}/> : null}

            {showTab('weapons') ? <Weapons/> : null}

            {showTab('armor') ? <Armor/> : null}

            {showTab('matrixspell') ? <MatriceSpell roll={false}/> : null}

            {showTab('threads') ? <Threads/> : null}

            {showTab('bloodmagic') ? <Fragment>
                <BloodMagicItems/>
            </Fragment> : null}

        </div>

        <div className={'footer'}>

            {!s_app_mobile.value ?
                <Paper style={{height: '100%'}}>
                    <span className="text-muted" style={{paddingLeft: 8, paddingRight: 8}}>&copy; 2025</span>
                    <span className="text-muted">Build: 4.0</span>
                    <IconButton onClick={() => {
                        s_app_toggleMobile()
                    }}><MobileFriendlyIcon/>
                    </IconButton>
                    <Button style={{float: 'right'}} onClick={() => logout()}>logout</Button>
                </Paper>
                :

                <Paper style={{height: '100%'}}>
                    <Select style={{width: '100%'}} value={tab}>
                        {menu.map((m, i) => (
                            <MenuItem key={m.k} value={m.k} onClick={() => {
                                s_app_mobile_tab.value = m.k;
                                setTab(m.k)
                            }}>{m.v}</MenuItem>
                        ))}
                        <MenuItem>
                            <Stack direction={'row'} justifyContent="flex-end" style={{width: '100%'}}>
                                <Button onClick={() => s_app_toggleMobile()}><ComputerIcon/></Button>
                                <Button onClick={() => logout()}>logout</Button>
                            </Stack>
                        </MenuItem>
                    </Select>
                </Paper>

            }
        </div>
    </Fragment>;
}

export default Main
